import { RefObject, useEffect, useState } from 'react';

export const useFitScale = (containerRef: RefObject<HTMLElement>,
  artboard: { width: number; height: number }, zoom: number | 'fit') => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;
    const measure = () => setSize({ width: element.clientWidth, height: element.clientHeight });
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [containerRef]);
  const fit = Math.min(2, Math.max(0.1, Math.min(
    (size.width - 32) / artboard.width, (size.height - 32) / artboard.height,
  )));
  const scale = zoom === 'fit' ? fit : zoom;
  return { scale, width: artboard.width * scale, height: artboard.height * scale };
};
